module.exports = __webpack_public_path__ + "./static/img/icondis-6.a7aba412f10e984dbfdcf6d4fdb49f7b.png";


//////////////////
// WEBPACK FOOTER
// ./client/src/assets/img/company/icondis-6.png
// module id = ./client/src/assets/img/company/icondis-6.png
// module chunks = 0